export default function LanguageSelector({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  return (
    <div className="flex items-center gap-2 px-3 py-2 text-on-surface hover:bg-surface-container-low dark:hover:bg-slate-800 rounded-lg transition-all cursor-pointer w-auto">
      <span className="material-symbols-outlined text-[20px]">translate</span>
      <select className="bg-transparent border-none outline-none font-medium text-sm cursor-pointer appearance-none" value={value} onChange={e => onChange(e.target.value)}>
        <option value="en">EN</option>
        <option value="fr">FR</option>
        <option value="de">DE</option>
        <option value="es">ES</option>
        <option value="pt">PT</option>
        <option value="it">IT</option>
        <option value="zh">ZH</option>
        <option value="ja">JA</option>
        <option value="ko">KO</option>
        <option value="ru">RU</option>
        <option value="ar">AR</option>
        <option value="hi">HI</option>
        <option value="nl">NL</option>
        <option value="sv">SV</option>
        <option value="tr">TR</option>
      </select>
    </div>
  )
}